import withAccount, { WithAccountProps } from 'hoc/withAccount'
import { AppointmentNote } from 'hooks/useAppointments/useAppointmentNotes'
import useAppointments from 'hooks/useAppointments/useAppointments'
import { memo, useMemo, useState } from 'react'
import { Table } from 'react-bootstrap'
import { BookingEventSource } from 'utils/amplitude.types'
import AppointmentNoteModal from './AppointmentNoteModal'
import AppointmentTableRow from './AppointmentTableRow'

const DEFAULT_NUM_SHOWN = 5

const PastAppointments: React.FC<WithAccountProps> = ({ user }) => {
  const { nonCancelledAppointments } = useAppointments()

  const [showNote, setShowNote] = useState<AppointmentNote | null>(null)
  const [showAllAppointments, setshowAllAppointments] = useState<boolean>(false)

  const handleshowAllAppointments = () => setshowAllAppointments(true)
  const handleShowFewer = () => setshowAllAppointments(false)
  const hideShowNoteDialog = () => setShowNote(null)

  const appointmentsToShow = useMemo(
    () =>
      showAllAppointments
        ? nonCancelledAppointments
        : nonCancelledAppointments.slice(0, DEFAULT_NUM_SHOWN),
    [showAllAppointments, nonCancelledAppointments]
  )

  return (
    <>
      <div className="appointment-container d-flex flex-wrap justify-content-between align-items-center">
        <p className="spaced-capital-letters mt-4">Appointments</p>
      </div>
      {appointmentsToShow.length ? (
        <>
          <Table borderless className="mb-2">
            <tbody>
              {appointmentsToShow.map((appointment) => (
                <AppointmentTableRow
                  key={appointment.id}
                  appointment={appointment}
                  handleSelectNote={setShowNote}
                />
              ))}
            </tbody>
          </Table>
          {showAllAppointments && (
            <p
              onClick={handleShowFewer}
              className="spaced-capital-letters btn-text fs-1 pl-2"
            >
              Show less
            </p>
          )}
          {!showAllAppointments &&
            nonCancelledAppointments.length > DEFAULT_NUM_SHOWN && (
              <p
                onClick={handleshowAllAppointments}
                className="spaced-capital-letters btn-text fs-1 pl-2"
              >
                See All
              </p>
            )}
          <AppointmentNoteModal
            note={showNote}
            onHide={hideShowNoteDialog}
            openFrom={BookingEventSource.APPOINTMENT_NOTE}
            user={user}
          />
        </>
      ) : (
        <>
          <p className="mt-4">
            You currently don&apos;t have any past appointments.
          </p>
          <p className="fs-2">
            Once you have your first appointment, you&apos;ll see a record of it
            here along with a post-appointment note from your provider.
          </p>
        </>
      )}
    </>
  )
}

export default memo(withAccount(PastAppointments))
